import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import "./AppHome.css";

export default function MembershipExpired() {
     const { state } = useLocation();
      const navigate = useNavigate();

  return (
    <div className="welcome-container2">
      <div className="welcome-Regi-card">
        <h1>❌ Membership Expired</h1>
        <p>Your membership expired on:</p>
        <h3>{new Date(state?.nextDueDate).toDateString()}</h3>
        <p>Please make payment to continue.</p>

        <div className="icon-circle">✓</div>

                <h1>Your attendance has been marked successfully!</h1>
                <p>Thank you for your cooperation.</p>



      </div>
    </div>
  );
}
